<form [formGroup]="foodForm" (submit)="register()">
  <div class="row">
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'admin.food.food-name' | translate}}</span>
      <input
        formControlName="name"
        type="text"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('name')?.invalid &&
          foodForm.get('name')?.touched
        "
        placeholder="{{ 'food-calibration.food-name-placeholder' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('name')?.invalid &&
          foodForm.get('name')?.touched
        "
      >
        {{ "admin.admins.error-name" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'tables.description' | translate}}</span>
      <input
        formControlName="description"
        type="text"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('description')?.invalid &&
          foodForm.get('description')?.touched
        "
        placeholder="{{ 'tables.description' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('description')?.invalid &&
          foodForm.get('description')?.touched
        "
      >
        {{ "clients.tasks.form.description-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'admin.food.food-brand' | translate}}</span>
      <select
        (change)="getProductsByBrand()"
        formControlName="brand"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('brand')?.invalid &&
          foodForm.get('brand')?.touched
        "
      >
        <option value="-1" disabled>{{'admin.food.select-brand' | translate}}</option>
        <option *ngFor="let item of foodBrands" [value]="item.name">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('brand')?.invalid &&
          foodForm.get('brand')?.touched
        "
      >
        {{ "admin.food.brand-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'tables.product' | translate}}</span>
      <select
        formControlName="product"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('product')?.invalid &&
          foodForm.get('product')?.touched
        "
      >
        <option value="-1" disabled>{{'admin.food.select-product' | translate}}</option>
        <option *ngFor="let item of foodProducts" [value]="item.name">{{item.name}}</option>
      </select>
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('product')?.invalid &&
          foodForm.get('product')?.touched
        "
      >
        {{ "food-calibration.product-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'admin.food.kg-presentation' | translate}}</span>
      <input
        formControlName="kg"
        type="number"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('kg')?.invalid &&
          foodForm.get('kg')?.touched
        "
        placeholder="{{ 'clients.feed-projection.diet-selection.kilograms' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('kg')?.invalid &&
          foodForm.get('kg')?.touched
        "
      >
        {{ "clients.cycles.multiple-harvest.kilograms-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-4 mt-2">
      <span>{{'admin.food.particle-size' | translate}}</span>
      <input
        formControlName="particle_size"
        type="number"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('particle_size')?.invalid &&
          foodForm.get('particle_size')?.touched
        "
        placeholder="{{ 'food-calibration.particle-size-placeholder' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('particle_size')?.invalid &&
          foodForm.get('particle_size')?.touched
        "
      >
        {{ "food-calibration.particle-size-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-6 mt-2">
      <span>{{'admin.food.price' | translate}}</span>
      <input
        formControlName="price"
        type="number"
        class="form-control"
        [class.is-invalid]="
          foodForm.get('price')?.invalid &&
          foodForm.get('price')?.touched
        "
        placeholder="{{ 'admin.food.price' | translate }}"
      />
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('price')?.invalid &&
          foodForm.get('price')?.touched
        "
      >
        {{ "food-calibration.price-required" | translate }}
      </span>
    </div>
    <div class="col-sm-12 col-lg-6 mt-2">
      <span>{{ "food-calibration.protein-percentage" | translate }} (%)</span>
      <div class="position-relative">
        <input
          type="text"
          class="form-control"
          formControlName="protein"
          [class.is-invalid]="
            (foodForm.get('protein')?.invalid &&
            foodForm.get('protein')?.touched) ||
            (foodForm.controls['protein'].value < 0 || foodForm.controls['protein'].value > 100)
          "
          placeholder="{{ 'food-calibration.protein-percentage' | translate }}"
        />
        <span class="position-percent">%</span>
      </div>
      <span
        class="text-danger"
        *ngIf="
          foodForm.get('protein')?.invalid &&
          foodForm.get('protein')?.touched &&
          !(foodForm.controls['protein'].value < 0 || foodForm.controls['protein'].value > 100)
        "
      >
        {{ "food-calibration.protein-percentage-required" | translate }}
      </span>
      <span
        class="text-danger"
        *ngIf="foodForm.controls['protein'].value < 0 || foodForm.controls['protein'].value > 100 "
        >{{ "food-calibration.value-out-of-range" | translate }}</span
      >
    </div>

    <div
      class="col-12 d-flex justify-content-end align-items-center mt-4"
      *ngIf="section === 'feed' || !edit"
    >
      <button class="btn btn-success btn-space" type="submit">
        <app-spinner [smallLoader]="true" [spinnerColor]="'text-white'" *ngIf="loadingSubmit">
        </app-spinner>
        <span class="m-0" *ngIf="!loadingSubmit"> {{ "general.finish" | translate }} </span>
      </button>
    </div>
  </div>
</form>
<hr />

<div *ngIf="edit">
  <div class="row text-center mt-2" *ngIf="router.url === '/calibration'">
    <div class="col-4">
      <div class="d-flex flex-column">
        <div>{{ "alerts.general.dispenser" | translate }}</div>
        <div class="mt-3 text-center">
          <b>{{dispenser ? dispenser.name : ''}}</b>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="d-flex flex-column">
        <div>{{ "admin.food.batch" | translate }}</div>
        <div class="mt-3">
          <input type="date" class="form-control" [(ngModel)]="batch" name="batch" />
          <div class="c-pointer" *ngIf="batchCalibration" (click)="batch = batchCalibration;">
            {{ "food-calibration.previous-batch-rate" | translate }}: {{batchCalibration}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-4">
      <div class="d-flex flex-column">
        <div>
          {{ "tables.feed-rate" | translate }}
          <div class="mt-3">
            <input type="number" class="form-control" [(ngModel)]="feedRecomended" />
          </div>
        </div>
        <div class="c-pointer" *ngIf="feedCalibration" (click)="feedRecomended = feedCalibration;">
          {{ "tables.feed-rate" | translate }} {{ "food-calibration.previous" | translate }}: {{feedCalibration}}
        </div>
      </div>
    </div>
    <div class="col-12">
      <button class="btn btn-success btn-space mt-4" type="submit" (click)="submitCalibration()">
        {{'general.finish' | translate}}
      </button>
    </div>
  </div>
  <!-- Calibracion por dosificador: una tarjeta por dosificador (lote + tasa + guardar) -->
  <ng-container *ngIf="router.url !== '/calibration'">
    <h5 class="calibration-title">{{ "food-calibration.dispensers" | translate }}</h5>
    <div class="calibration-list">
      <div class="calibration-card" *ngFor="let item of calibrationsFood; let i = index">
        <p class="calibration-card-name">{{ item.dispenser ? item.dispenser.name : "" }}</p>
        <div class="calibration-card-fields">
          <label class="calibration-field calibration-field-batch">
            <small>{{ "admin.food.batch" | translate }}</small>
            <input type="date" class="form-control" [(ngModel)]="item.batch" name="batch" />
          </label>
          <label class="calibration-field calibration-field-rate">
            <small>{{ "tables.feed-rate" | translate }}</small>
            <input type="number" class="form-control" [(ngModel)]="item.feed_rate" />
          </label>
          <button
            [disabled]="item.batch === '' || item.feed_rate === ''"
            class="btn btn-success calibration-save"
            type="submit"
            [attr.aria-label]="'general.save' | translate"
            (click)="editCalibration(item, i)"
          >
            <em class="fa fa-save"></em>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
